import Leaflet from "./leaflet"

// LeafletView チラシ画像を管理する view model クラス
// チラシ画像のロードなどのイベントアサインやレンダリングを管理する
class LeafletView {
  constructor(sceneView) {
    this.sceneView = sceneView
    this.element = $('.scene .leaflet')
    this.leaflet = new Leaflet(this, this.sceneView.scene)
    this.assignEvent()
  }

  initialize() {
    this.element.removeClass('transparent')
    return this.sceneView.deferred.resolve()
  }

  render(animate = false) {
    const size = this.leaflet.size()
    const position = this.leaflet.position()
    if (animate) {
      return this.element.animate(
        {
          width: size.width,
          height: size.height,
          top: `${position.top}px`,
          left: `${position.left}px`,
        },
        {
          duration: 180,
        }
      )
    } else {
      return this.element
        .width(size.width)
        .height(size.height)
        .css({
          top: `${position.top}px`,
          left: `${position.left}px`,
        })
    }
  }

  changeLeaflet(leafletObject) {
    if (this.element.attr('src') === leafletObject.high_resolution_image_url) {
      return
    }
    this.element.attr('src', leafletObject.high_resolution_image_url)
    // 閲覧時間計測（send_view_time_log）に使用するdata属性を設定
    if (leafletObject.data_view_time_log_attributes) {
      this.element.attr('data-view-time-log', leafletObject.data_view_time_log_attributes)
    }
    return this.assignEvent()
  }

  assignEvent() {
    // If the leaflet image was loaded
    if (this.element.width() > 0) {
      return this.leaflet.initialize()
    } else {
      return this.element.on('load', () => {
        return this.leaflet.initialize()
      })
    }
  }
}

export default LeafletView;
